import DatePicker, { registerLocale } from "react-datepicker";
import ptBR from 'date-fns/locale/pt-BR';
import "react-datepicker/dist/react-datepicker.css";
import { MdCalendarToday } from 'react-icons/md';
import "./index.css";
import { useState, useRef } from "react";
import { convertDateToBrazilianFormat, eraseBarOfGenericMask, newSetMaskGeneric, setMaskGeneric } from "../../../classes/functions";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { useEffect } from "react";

registerLocale('pt-br',ptBR)

export default function InputDate({filters, propertyFilter, setFilters, disabled}){
    const [showCalendar, setShowCalendar] = useState(false);
    const inputDate = useRef(null);

    function getChoosedDate(date){
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${day}/${month}/${year}`;
    }

    function checkIfUserIsInsertingOrRemovingValue(inputType, value){
        if(inputType === "insertText"){
            setFilters((prevState) => ({...prevState, [propertyFilter] : setMaskGeneric(value, "##/##/####")}))
        } else if(inputType === "deleteContentBackward"){
            setFilters((prevState) => ({...prevState, [propertyFilter] : eraseBarOfGenericMask(value)}))
        }
    }

    function onClickOutside(event){
        if(!event.target || !inputDate?.current?.contains(event.target)){
            setShowCalendar(false);
        }
    }

    useEffect(() => {
        document.addEventListener("click", onClickOutside);
        
        return () => {
            document.removeEventListener("click", onClickOutside);
        }
    }, []);

    return (
        <div ref={inputDate} title={`input_date-${propertyFilter}`}>
            <div className="input-calendar">
                <input 
                    type="text" 
                    placeholder="##/##/####" 
                    className="input-calendar__input"
                    onBlur={() => setShowCalendar(false)}
                    value={filters[propertyFilter]} 
                    onChange={(e) => checkIfUserIsInsertingOrRemovingValue(e.nativeEvent.inputType, e.target.value)}
                    maxLength="12"
                    disabled={disabled}
                    title={propertyFilter}
                />  
                <MdCalendarToday className="input-calendar__icon" onClick={() => setShowCalendar(!showCalendar)} xlinkTitle={propertyFilter} title={propertyFilter} />
            </div>
            {showCalendar && !disabled &&
                <Calendar onChange={(value) => setFilters((prevState) => ({...prevState, [propertyFilter]: getChoosedDate(value)}))} locale={ptBR} />
            }
        </div>
    );
}